import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { QuizQuestion, QuizChoice } from '../../shared/models';
import { MarkdownService } from '../../../services/markdown.service';

@Component({
  selector: 'ut-academy-quiz-question',
  templateUrl: './quiz-question.component.html',
  styleUrls: ['./quiz-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuizQuestionComponent {
  @Input() question!: QuizQuestion;
  @Input() selectedChoiceId: number | null = null;
  @Output() answerSelected = new EventEmitter<number>();

  @ViewChild('questionText', { static: false }) questionTextElement?: ElementRef<HTMLElement>;

  private readonly letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  constructor(
    private markdownService: MarkdownService,
  ) {}

  getQuestionHtml(content: string): string {
    if (!content) return '';
    return this.markdownService.renderMarkdown(content);
  }

  stripHtml(content: string): string {
    if (!content) return '';
    return this.markdownService.renderMarkdown(content).replace(/<[^>]*>/g, '');
  }

  getLetterForIndex(index: number): string {
    return this.letters[index] || String(index + 1);
  }

  onChoiceSelected(choiceId: number): void {
    this.answerSelected.emit(choiceId);
  }

  isChoiceSelected(choice: QuizChoice): boolean {
    return this.selectedChoiceId === choice.id;
  }

  focusQuestion(): void {
    this.questionTextElement?.nativeElement.focus();
  }
}
